import React, {Component} from 'react';
import {SelectList} from './FormUI';
import InitialsIcon from './InitialsIcon';
import './NameSelectList.css';

export default class NameSelectList extends Component{

    constructor(props){
        super(props);
        this.state = {name:(props.value || {}).label, selected:props.value};
        this.handleOnChangeRaw = this.handleOnChangeRaw.bind(this);
        this.onRefUpdate = this.onRefUpdate.bind(this);
    }

    

    handleOnChangeRaw(val){
        console.log("Name Selected:", val)
        let v = val || {label:""};
        this.setState({name: v.label, selected: val});
    }

    onRefUpdate(select){
        this.__select = select;
    }

    componentDidUpdate(){
        console.log("Component Did Update:", this.state)
        if(!this.__select.value)return;
        if(this.state.name != this.__select.value.label){
            this.setState({name: this.__select.value.label});
        }
    }


    render(){
        let {onChangeRaw, ref, ...props} = this.props;
        return(
            <div className="name-select-list">
                <div className="table align-middle hmax">
                    <div>
                        <div className="icon-holder">
                            <InitialsIcon name={this.state.name} />
                        </div>
                        <div className="select-list-holder">
                            <SelectList onChangeRaw={this.handleOnChangeRaw} value={this.state.selected} ref={this.onRefUpdate} {... props} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NameSelectList.js